document.addEventListener("DOMContentLoaded", () => {

  /*
  ============================================
  DISCOUNT CONFIG
  ============================================
  */

  const DISCOUNT_RULES = {};

  let blockedCustomCode = null;
let currentEnteredCode = null;

/*
============================================
SHOPIFY DISCOUNT VALIDATION
============================================
*/

const originalFetch = window.fetch;

window.fetch = async (...args) => {
  const response = await originalFetch(...args);

  try {
    const url = String(args[0]);

    if (url.includes("/graphql.json")) {
      const clone = response.clone();
      const data = await clone.json();

      const discountCode =
        data?.data?.cartDiscountCodesUpdate?.cart?.discountCodes?.[0];

      if (discountCode) {

        // Ignore Shopify response for codes
        // already blocked by custom validation
        if (
          blockedCustomCode &&
          discountCode.code?.toUpperCase() === blockedCustomCode
        ) {
          return response;
        }

        const form = document.querySelector(
          ".ocu-discount-apply__form"
        );

        if (form) {
          if (discountCode.applicable === false) {

            showDiscountError(
              form,
              "Dieser Rabattcode kann nicht angewendet werden."
            );

          } else {

            removeDiscountError();

          }
        }
      }
    }
  } catch (err) {
    console.error("Discount validation:", err);
  }

  return response;
};
  /*
  ============================================
  INIT
  ============================================
  */

  function initDiscountValidation() {

    const form =
      document.querySelector('.ocu-discount-apply__form');

    if (!form) return;

    if (form.dataset.validationAttached) return;

    form.dataset.validationAttached = "true";

    form.addEventListener("submit", async (e) => {

      const input =
        form.querySelector('.ocu-discount-apply__input');

      if (!input) return;

      const code =
        input.value.trim().toUpperCase();

        currentEnteredCode = code;
blockedCustomCode = null;

      if (!code) return;

      const rule = DISCOUNT_RULES[code];

      // No custom rule → allow Shopify to handle
      if (!rule) {
        removeDiscountError();
        return;
      }
      const cart =
        await fetch('/cart.js').then(r => r.json());

      const subtotal =
        cart.total_price / 100;

      let errorMessage = "";

      /*
      ============================================
      EXPIRED
      ============================================
      */

      if (rule.expired) {

        errorMessage = rule.message;
      }

      /*
      ============================================
      MIN SUBTOTAL
      ============================================
      */

      if (
        !errorMessage &&
        rule.minSubtotal &&
        subtotal < rule.minSubtotal
      ) {

        if (rule.dynamicRemaining) {

          const missing =
            (rule.minSubtotal - subtotal).toFixed(2);

          errorMessage =
            `Du benötigst noch €${missing} für diesen Rabattcode.`;

        } else {

          errorMessage = rule.message;
        }
      }

      /*
      ============================================
      PRODUCT TYPE VALIDATION
      ============================================
      */

      if (
        !errorMessage &&
        rule.allowedProductTypes
      ) {

        const eligible =
          cart.items.some(item => {

            const type =
              item.product_type?.toLowerCase();

            return rule.allowedProductTypes.includes(type);

          });

        if (!eligible) {

          errorMessage = rule.message;
        }
      }

      /*
      ============================================
      SALE ITEM EXCLUSION
      ============================================
      */

      if (
        !errorMessage &&
        rule.excludeSaleItems
      ) {

        const hasSaleItems =
          cart.items.some(item =>
            item.final_price < item.original_price
          );

        if (hasSaleItems) {

          errorMessage = rule.message;
        }
      }

      /*
      ============================================
      BLOCK SUBMISSION
      ============================================
      */

      if (errorMessage) {

        blockedCustomCode = code;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        showDiscountError(form, errorMessage);

        return false;
      }

blockedCustomCode = null;
      removeDiscountError();

    });

  }

  /*
  ============================================
  ERROR UI
  ============================================
  */

  function showDiscountError(form, message) {

    removeDiscountError();

    const error = document.createElement('div');

    error.className =
      'custom-discount-error';

    error.textContent = message;

    form.parentNode.appendChild(error);
  }

  function removeDiscountError() {

    const existing =
      document.querySelector('.custom-discount-error');

    if (existing) {
      existing.remove();
    }
  }

  /*
  ============================================
  OBSERVER
  ============================================
  */

  const observer =
    new MutationObserver(() => {

      initDiscountValidation();
    });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  initDiscountValidation();

});